import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { MembershipRole, type UserPayload } from '@/store/types'
import { useTeamStore } from '@/pinia/useTeamStore'
import { getHighestRole } from '@/modules/Teams/getHighestRole'

/**
 * The primary store that holds logged in user info
 */
export const useUserStore = defineStore('user', () => {
  const teamStore = useTeamStore()

  const loadingUser = ref(false)
  const currentUser = ref<UserPayload | null>(null)

  const currentUserId = computed<number | undefined>(() => currentUser.value?.id)

  const currentUserMemberships = computed(() =>
    teamStore.allRelevantMemberships.filter((member) => member.user_id === currentUserId.value),
  )
  const highestTeamRole = computed(() =>
    currentUserMemberships.value.length > 0
      ? getHighestRole([...currentUserMemberships.value])
      : undefined,
  )

  const isAnnotator = computed(() => highestTeamRole.value === MembershipRole.ANNOTATOR)
  const isWorkforceManager = computed(
    () => highestTeamRole.value === MembershipRole.WORKFORCE_MANAGER,
  )
  return {
    currentUser,
    currentUserId,
    loadingUser,
    highestTeamRole,
    isAnnotator,
    isWorkforceManager,
  }
})
